// extracted by mini-css-extract-plugin
module.exports = {"orderHistoryOverview":"FB","errorMsg":"GB"};